<template>
    <div id="bg" class="color surface-0 flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
        <Toast />
        <loading
    :active="isLoadingModel"
    :can-cancel="true"
    
    color=var(--primary-color)
    :is-full-page="fullPage"
  ></loading>
        <div class="grid justify-content-center p-2 lg:p-0" style="min-width:60%">
            
            <div class="col-12 mt-5 xl:mt-0 text-center">
                <img src="images/cmrfLogo.png" alt="Mahajyoti logo" class="mb-2" height="100">               
            </div>
            <div class="col-12 mt-5 xl:mt-0 text-center">
                <b style="text-align: center;width: 75%;"><h1>Chief Minister  <span> Relief Fund</span></h1></b>
            </div>
            <div class="col-12 xl:col-6" style="border-radius:56px; padding:0.3rem;     background: var(--primary-color)
">
                <div class="h-full w-full m-0 py-7 px-4" style="border-radius:50px; background: #FFFFFF">
                    <div class="text-center mb-5">
                        <!-- <img src="layout/images/avatar.png" alt="Image" height="50" class="mb-3"> -->
                        <!-- <b style="text-align: center;width: 75%;"><h1>Chief Minister  <span> Relief Fund</span></h1></b> -->
                        <!-- <div class="text-900 text-3xl font-medium mb-3">Welcome, Isabel!</div>
                        <span class="text-600 font-medium">Sign in to continue</span> -->
                    </div>
                
                    <div class="w-full md:w-10 mx-auto">
                        <label for="email1" class="block text-900 text-xl font-medium mb-2">Username</label>
                        <InputText  id="email1" v-model="email" type="text" class="w-full mb-3 zoom" placeholder="Username" style="padding:1rem;" />
                        <!-- <InlineMessage v-if="email==''">Username is required</InlineMessage> -->

                        <label for="password1" class="block text-900 font-medium text-xl mb-2">Password</label>
                        <Password  :feedback="false" id="password1" v-model="password" placeholder="Password" :toggleMask="true" class="w-full mb-3 zoom" inputClass="w-full" inputStyle="padding:1rem"></Password>
                        <!-- <InlineMessage v-if="password==''">Password is required</InlineMessage> -->

                        <!-- <label for="type" class="block text-900 text-xl font-medium mb-2">User Type</label>
                        <Dropdown id="state" v-model="user_type" :options="dropdownItems" :toggleMask="true" optionLabel="name" placeholder="Select One" class="w-full mb-3" inputClass="w-full" inputStyle="padding:1rem"></Dropdown>
                        <InlineMessage v-if="show==true">UserType is required</InlineMessage> -->
                
                        <div class="flex align-items-center justify-content-between mb-5">
                            <!-- <div class="flex align-items-center">
                                <Checkbox id="rememberme1" v-model="checked" :binary="true" class="mr-2"></Checkbox>
                                <label for="rememberme1">Remember me</label>
                            </div>
                            <a class="font-medium no-underline ml-2 text-right cursor-pointer" style="color: var(--primary-color)">Forgot password?</a> -->
                        </div>
                        
                        <Button label="Sign In" class="w-full p-3 text-xl button zoom" @click="Login"> </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import apis from "@/apis";
export default {
    data() {
        return {
            isLoadingModel:false,
			fullPage:true,
            email: '',
            password: '',
            checked: false,
            show:false,
            user_type:'',
            dropdownItems: [
                    {name: 'Government', value: 'governmentuser'},
					{name: 'Admin', value: 'admin'},
					// {name: 'Teacher', value: 'teacher'},
					// {name: 'Assistent Teacher', value: 'assteacher'},
                    // {name: 'Student', value: 'student'},
                    // {name: 'Network Administrator', value: 'network'}
				],
        }
    },
    methods:{
      Login()
      {
        
        if(this.email==="" ||this.email===null ||this.email===undefined)
        {
            //alert("Please Enter Username");
            this.$toast.add({severity:'error', summary: 'Error Message', detail:'Please Enter Username', life: 3000});
            return false;
        }
        if(this.password==="" ||this.password===null ||this.password===undefined)
        {
            //alert("Please Enter Password");
            this.$toast.add({severity:'error', summary: 'Error Message', detail:'Please Enter Password', life: 3000});
            return false;
        }
        
        var data = 
         {
                "USERNAME":this.email,  
                "password":this.password, 
                
         };
         this.isLoadingModel = true;
		var promise = apis.login(data);
        promise
        .then(response => { 
            this.isLoadingModel = false;
        if(response.status==200)
        {
            console.log("loginData",response.data);
           
                localStorage.setItem("userData", JSON.stringify(response.data.governmentdata));
                localStorage.id = response.data.governmentdata["uid"];
                localStorage.token = response.data["token"];
                localStorage.full_name = response.data.governmentdata["name"];
                localStorage.email = response.data.governmentdata["email"]; 
                localStorage.user_role_id = response.data.governmentdata["user_role_id"];
                localStorage.profile_photo = response.data.governmentdata["profilE_PHOTO"];
            
            if(response.data.governmentdata["user_role_id"] == 7)
            {   
                localStorage.user_key = 'Audit_User'; 
                this.$router.push('/audituser_dashboard');        
                
            }
            else if(response.data.governmentdata["user_role_id"] == 8) 
            {   localStorage.user_key = 'Project_Manager';
                this.$router.push('/projectmanager_dashboard');
                
            }
            else if(response.data.governmentdata["user_role_id"] == 2) 
            {   localStorage.user_key = 'Admin';
                 this.$router.push('/dashboard');
            }
            else if(response.data.governmentdata["user_role_id"] == 4) 
            {   localStorage.user_key = 'Account_user';
                this.$router.push('/accountant_dashboard');
            }
            else if(response.data.governmentdata["user_role_id"] == 9) 
            {   localStorage.user_key = 'Chief Financial Officer';
                this.$router.push('/cfo_dashboard');
            }

        } 
        else if (response.status == 404 || response.status == 300) 
        {
              this.$toast.add({severity:'error', summary: 'Error Message', detail:'Invalid Login Credentials', life: 3000});
            return false;
        }  
            
            
        })
        .catch(error => {
            this.isLoadingModel = false;
            this.$toast.add({severity:'error', summary: 'Error Message', detail:'Invalid Login Credentials', life: 3000});
            return false;
            });
      }  
    },
    computed: {
        logoColor() {
            if (this.$appState.darkTheme) return 'white';
            return 'dark';
        }
    }
}
</script>

<style scoped>
.pi-eye {
    transform:scale(1.6);
    margin-right: 1rem;
}

.pi-eye-slash {
    transform:scale(1.6);
    margin-right: 1rem;
}
.zoom {
  transform-origin: 0% 0% 1% 1%;
  transition: transform 1s, filter 1s ease-in-out;
}
/* The Transformation */
.zoom:hover {
  transform: scale(1.05);
}
.button{
    background: var(--primary-color)
    
}
.button:hover{
    background: var(--primary-color)
    
}
#bg{
  background-image: url('/images/bg.jpg'); /* No import needed */
}
h1 {
    color: #efa40a;
    display: inline-block;
    font-family: "oswald_bold";
    font-size: 30px;
    font-weight: bolder;
    padding: 5px 0 0 0px;
    text-transform: uppercase;
}
h1 span {
    color: #09517a;
}
</style>